import { ChevronRight } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// 259: Nastavení jako seskupené řádky (styl Nastavení v iPhonu) — nadpis skupiny nad bílou
// kartou, řádky s popiskem vlevo a hodnotou / přepínačem vpravo, vysvětlivky za ikonou „i“.

export function InfoTip({ text, label = "Vysvětlení" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={label}
          className="w-[18px] h-[18px] rounded-full border-[1.5px] border-muted-foreground/50 text-muted-foreground text-[11px] font-bold italic font-serif inline-grid place-items-center hover:border-brand hover:text-brand normal-case tracking-normal">
          i
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[min(320px,calc(100vw-32px))] rounded-[14px] text-[13px] leading-relaxed text-muted-foreground">{text}</PopoverContent>
    </Popover>
  );
}

export function Group({ title, info, footer, children, testid, className = "" }) {
  return (
    <section className={`min-w-0 ${className}`} data-testid={testid}>
      {title && (
        <h3 className="flex items-center gap-1.5 px-1.5 md:px-4 pb-[7px] text-[12px] font-bold uppercase tracking-[.08em] text-muted-foreground">
          {title}{info && <InfoTip text={info} />}
        </h3>
      )}
      {/* telefon: stejné karty jako Menu (bez rámečku, oblé 20 px); počítač: s rámečkem jako ostatní karty */}
      <div className="rounded-[20px] md:rounded-[16px] bg-card md:border md:border-border overflow-hidden divide-y divide-border">{children}</div>
      {footer && <p className="px-1.5 md:px-4 mt-1.5 text-xs text-muted-foreground leading-relaxed">{footer}</p>}
    </section>
  );
}

// Řádek: na telefonu se pravá část smí zalomit pod popisek (wrap), jinak drží vedle.
// `field` (285): řádek s políčkem je <label> — klik kamkoli do řádku (i na název) dá kurzor do políčka.
export function Row({ label, sub, children, onClick, chevron, testid, icon, wrap, field, className = "" }) {
  const Tag = onClick ? "button" : field ? "label" : "div";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick} data-testid={testid}
      className={`w-full min-h-[54px] flex items-center gap-x-3 gap-y-2 px-3.5 md:px-4 py-2.5 text-left ${wrap ? "flex-wrap sm:flex-nowrap" : ""} ${onClick ? "hover:bg-secondary/60 active:bg-secondary transition-colors" : ""} ${field ? "cursor-text" : ""} ${className}`}>
      {icon}
      <span className={`min-w-0 ${wrap ? "basis-full sm:basis-auto" : ""} flex-1`}>
        <span className="block text-[16px] font-semibold md:text-[15px] md:font-medium leading-snug">{label}</span>
        {sub && <span className="block text-xs text-muted-foreground mt-0.5 leading-snug">{sub}</span>}
      </span>
      {children}
      {chevron && <ChevronRight size={17} className="text-muted-foreground/70 shrink-0" aria-hidden="true" />}
    </Tag>
  );
}

// Vstup v řádku: bez rámečku, zarovnaný doprava, při psaní šedý podklad
// 285: políčko je vidět i bez kliknutí (dřív průhledné — prázdné pole nebylo k nalezení)
export const rowInput = "h-10 min-w-0 w-[55%] sm:w-64 rounded-[10px] border-0 bg-secondary/70 px-2.5 text-right text-base md:text-[15px] hover:bg-secondary focus:bg-secondary focus:outline-none focus:ring-2 focus:ring-brand/40 placeholder:text-muted-foreground/60";

// Přepínač dvou až tří hodnot s posuvným podkladem (jako segmentový ovladač v iOS)
export function Segmented({ options, value, onChange, disabled, testid }) {
  const i = Math.max(0, options.findIndex((o) => o.value === value));
  return (
    <div role="group" data-testid={testid} className="relative grid p-0.5 rounded-[10px] bg-secondary shrink-0"
      style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}>
      <span aria-hidden="true" className="absolute top-0.5 bottom-0.5 left-0.5 rounded-[8px] bg-card shadow-sm transition-transform duration-500 ease-[cubic-bezier(.34,1.3,.64,1)] motion-reduce:transition-none"
        style={{ width: `calc((100% - 4px) / ${options.length})`, transform: `translateX(${i * 100}%)` }} />
      {options.map((o) => (
        <button key={String(o.value)} type="button" disabled={disabled} aria-pressed={o.value === value} data-testid={o.testid}
          onClick={() => o.value !== value && onChange(o.value)}
          className="relative z-[1] h-8 px-3.5 text-[13.5px] font-semibold whitespace-nowrap disabled:opacity-60">
          {o.label}
        </button>
      ))}
    </div>
  );
}
